import { Box, useTheme, TextField } from "@mui/material";
import { tokens } from "../../theme";
import { useState, useEffect } from "react";
// import useMediaQuery from "@mui/material/useMediaQuery";

import Cards from "react-credit-cards";
import "react-credit-cards/es/styles-compiled.css";

import FileCopyOutlinedIcon from "@mui/icons-material/FileCopyOutlined";

import InputLabel from "@mui/material/InputLabel";
// import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

import InputAdornment from "@mui/material/InputAdornment";

const CreditCardPlastic = ({ state, valuesCard, handleInputChangeCard, setValuesCard }) => {
	const theme = useTheme();
	const colors = tokens(theme.palette.mode);
	// const isNonMobile = useMediaQuery("(min-width: 800px)");
	const [focus, setFocus] = useState("expiryMonth");
	const [yearsSelect, setYearsSelect] = useState([]);

	const numberMonth = [
		"01",
		"02",
		"03",
		"04",
		"05",
		"06",
		"07",
		"08",
		"09",
		"10",
		"11",
		"12"
	];

	useEffect(() => {
		const generateYEars = () => {
			const currentYear = new Date().getFullYear().toString().slice(-2);
			console.log(typeof parseInt(currentYear));
			const usableYears = [];
			for (let i = 0; i < 11; i++) {
				const validYears = parseInt(currentYear) + i;
				usableYears.push(validYears.toString());
			}
			setYearsSelect(usableYears);
		};
		generateYEars();
	}, []);

	const handleInputFocus = e => {
		setFocus(e.target.name);
		if(e.target.name === 'ccv'){
			setFocus('cvc')
		}
	};

	const handlerPaste = async () => {
		// alert("clicado aqui no botao");
		navigator.clipboard
			.readText()
			.then(text => {
				console.log("Pasted content: ", text);
				setValuesCard({...valuesCard, number: text})
			})
			.catch(err => {
				console.error("Failed to read clipboard contents: ", err);
			});
	};

	useEffect(
		() => {
			const numberLen = document.getElementsByName("number")[0];
			const expiryMonthLen = document.getElementsByName("expiryMonth")[0];
			const expiryYearLen = document.getElementsByName("expiryYear")[0];
			const cvcLen = document.getElementsByName("ccv")[0];
			const btn = document.getElementsByName("submit-btn-plastic")[0];
			if (numberLen.value.length === 16) {
				if (expiryMonthLen.value.length === 2) {
					if (expiryYearLen.value.length === 2) {
						if (cvcLen.value.length === 3) {
							expiryYearLen.focus();
							btn.focus();
						}
					}
				}
			}
		},
		[handleInputChangeCard]
	);

	return (
		<Box
			display="flex"
			flexDirection="column"
			justifyContent="center"
			alignItems="center"
			sx={{
				backgroundColor: colors.pink[600],
				border: " 1px solid black",
				padding: "20px",
				margin: "0px 10px",
				height: "450px",
				borderRadius: "10px",
				"& .rccs__card--front , .rccs__card--back": {
					padding: "20px"
					// marginTop: "-80px"
				},
				"& .rccs": {
					marginBottom: "50px"
				}
			}}
		>
			<div id="PaymentForm">
				<Cards
					cvc={valuesCard.ccv}
					expiry={`${valuesCard.expiryMonth}/${valuesCard.expiryYear}`}
					focused={focus}
					name={state.creditCardHolderInfo.name}
					number={valuesCard.number}
				/>
				<form>
					<Box
						display="grid"
						gap="30px"
						gridTemplateColumns="repeat(12, minmax(0, 1fr))"
						alignItems="center"
						justifyContent="space-between"
						sx={{
							width: "100%",
							"& .MuiInputBase-input": {
								backgroundColor: `${colors
									.pink[700]} !important`
							},
							"& .Mui-focused": {
								color: "white"
							}
						}}
					>
						<Box
							display="grid"
							gridTemplateColumns="repeat(12, minmax(0, 1fr))"
							gap="10px"
							justifyContent="space-between"
							alignItems="center"
							sx={{
								gridColumn: "span 12"
							}}
						>
							<TextField
								fullWidth
								required
								onFocus={handleInputFocus}
								variant="outlined"
								id={valuesCard.number}
								type="tel"
								label="Número do Cartão"
								onChange={handleInputChangeCard}
								name="number"
								value={valuesCard.number}
								placeholder="xxxx xxxx xxxx xxxx"
								inputProps={{
									maxLength: 16
								}}
								sx={{
									gridColumn: "span 12",
									backgroundColor: `${colors
										.pink[700]} !important`
								}}
								InputProps={{
									inputMode: "numeric",
									pattern: "[0-9]*",
									endAdornment: (
										<InputAdornment position="end">
											<FileCopyOutlinedIcon
												onClick={handlerPaste}
												sx={{
													cursor: "pointer"
												}}
											/>
										</InputAdornment>
									)
								}}
							/>
						</Box>
						<Box
							display="flex"
							justifyContent="space-between"
							alignItems="center"
							sx={{
								gridColumn: "span 12"
							}}
							id="marcelo"
						>
							<Box
								display="flex"
								justifyContent="start"
								alignItems="center"
								gap="10px"
								width="50%"
							>
								<FormControl sx={{ width: "100%" }}>
									<InputLabel id="demo-select-small">
										MM
									</InputLabel>
									<Select
										native
										labelId="demo-select-small"
										id="demo-select-small"
										value={valuesCard.expiryMonth}
										label="MM"
										onChange={handleInputChangeCard}
										onFocus={handleInputFocus}
										// variant="outlined"
										name="expiryMonth"
										placeholder="MM"
									>
										<option value="">
											
										</option>
										{numberMonth.map((month, i) => {
											return (
												<option key={i} value={month}>
													{month}
												</option>
											);
										})}
									</Select>
								</FormControl>
								<FormControl sx={{ width: "100%" }}>
									<InputLabel id="input-select-expiryYear">
										AA
									</InputLabel>
									<Select
										native
										labelId="select-expiryYear"
										id="select-expiryYear"
										value={valuesCard.expiryYear}
										label="AA"
										onChange={handleInputChangeCard}
										onFocus={handleInputFocus}
										// variant="outlined"
										name="expiryYear"
										placeholder="AA"
									>
										<option value="">
											
										</option>
										{yearsSelect.map((year, i) => {
											return (
												<option key={i} value={year}>
													{year}
												</option>
											);
										})}
									</Select>
								</FormControl>
							</Box>
							<Box
								display="flex"
								justifyContent="end"
								alignItems="center"
								width="30%"
							>
								<TextField
									fullWidth
									required
									onFocus={handleInputFocus}
									variant="outlined"
									id={valuesCard.ccv}
									type="tel"
									label="CVC"
									onChange={handleInputChangeCard}
									name="ccv"
									value={valuesCard.ccv}
									placeholder="CVC"
									inputProps={{
										maxLength: 3
									}}
								/>
							</Box>
						</Box>
					</Box>
				</form>
			</div>
		</Box>
	);
};

export default CreditCardPlastic;
